var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_ionic-ios-close-circle",
    x: 0,
    y: 0,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_ionic-ios-close-circle)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle-2",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M15.875,3.375a12.5,12.5,0,1,0,12.5,12.5A12.5,12.5,0,0,0,15.875,3.375ZM19.042,20.4l-3.167-3.167L12.708,20.4a.96.96,0,1,1-1.358-1.358l3.167-3.167L11.35,12.708a.96.96,0,0,1,1.358-1.358l3.167,3.167,3.167-3.167A.96.96,0,0,1,20.4,12.708l-3.167,3.167L20.4,19.042a.965.965,0,0,1,0,1.358A.954.954,0,0,1,19.042,20.4Z",
    transform: "translate(5.63 0.63)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/Icon-error.1044523644cff407d4a1e637ab6240c7.svg";
export { ForwardRef as ReactComponent };